module.exports = __webpack_public_path__ + "img/IMG016.c069e31f.jpg";